// Универсальный попап-уведомление — замена нативного alert(). showAlert(message)
// ставит текст в попап и открывает его (открытие/закрытие — общий Popup.js).
// Если попапа на странице нет — фолбэк на нативный alert().

export function showAlert(message) {
	const box = document.querySelector('[data-popup-name="alert"]');
	if (!box || !window.popup || typeof window.popup.open !== "function") {
		window.alert(message);
		return;
	}
	const msgEl = box.querySelector("[data-alert-message]");
	if (msgEl) msgEl.textContent = message || "";
	window.popup.open("alert");

	// Фокус на кнопке «Понятно» → Enter (активация кнопки) закрывает попап.
	const ok = box.querySelector('[data-popup-close="alert"]');
	if (ok) requestAnimationFrame(() => ok.focus());
}
